import { AxiosResponse } from "axios";
import { PixPayment } from "@ribondao/shared/types";
import { apiPost } from "..";

const pixPaymentApi = {
  postPixPayment: (
    paymentInformation: PixPayment,
  ): Promise<AxiosResponse<any>> => apiPost("payments/pix", paymentInformation),
};

export default pixPaymentApi;
